<h2>{{ 'benefits.benefit-mgt.title' | translate | titlecase }}</h2>

<div [hidden]="!hasEventBenefits" class="form-horizontal">
  <p [hidden]="!showBenefitHelp" class="text-danger">
    {{ 'benefits.messages.no-benefit-codes-1' | translate }}
    <a href="https://support.weblinkinternational.com/hc/en-us/articles/115006207288" target="_blank">{{
      'benefits.messages.no-benefit-codes-2' | translate
      }}</a>
    {{ 'benefits.messages.no-benefit-codes-3' | translate }}
  </p>
  <div class="form-group">
    <div class="col-sm-6">
      <div class="input-group">
        <input [(ngModel)]="benMgtComonentModel.searchParams.Keyword" type="text" class="form-control" />
        <span class="input-group-btn">
          <button pButton type="button" [disabled]="isSearching" class="btn btn-default" icon="pi pi-search"
            (click)="searchBenefits()"></button>
          <button pButton type="button" class="btn btn-default" icon="pi pi-times-circle"
            (click)="clearBenefits()"></button>
        </span>
      </div>
    </div>

    <div class="col-sm-3">
      <a (click)="handleShowAdvancedSearch()" *ngIf="!benMgtComonentModel.showAdvancedSearch">
        {{ 'common.advanced' | translate | titlecase }} {{ 'common.search' | translate | titlecase }}
      </a>
      <a (click)="handleHideAdvancedSearch()" *ngIf="benMgtComonentModel.showAdvancedSearch">
        {{ 'common.hide' | translate | titlecase }} {{ 'common.advanced' | translate | titlecase }}
        {{ 'common.search' | translate | titlecase }}
      </a>
    </div>
  </div>

  <wl-benefit-mgt-advanced-search [(searchParams)]="benMgtComonentModel.searchParams" class="form-group"
    [hidden]="!benMgtComonentModel.showAdvancedSearch"></wl-benefit-mgt-advanced-search>

  <div class="form-group">
    <div class="col-sm-6">
      <button pButton type="button" [disabled]="loading.busy" class="btn btn-default" icon="pi pi-search"
        [label]="'common.search' | translate | titlecase" (click)="searchBenefits()"
        *ngIf="benMgtComonentModel.showAdvancedSearch"></button>
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-6">
      <div class="input-group">
        <select class="form-control" [(ngModel)]="selectedAction">
          <option value="0">{{ 'common.select' | translate | titlecase }} {{ 'common.action' | translate | titlecase
            }}...</option>
          <option value="1">{{ 'benefits.benefit-mgt.actions.add-a-benefit-option' | translate | titlecase }}</option>
          <option value="2">{{ 'benefits.benefit-mgt.actions.flag-a-benefit-option' | translate | titlecase }}</option>
          <option value="3">{{ 'benefits.benefit-mgt.actions.renew-option' | translate | titlecase }}</option>
        </select>
        <span class="input-group-btn">
          <button pButton type="button" class="btn btn-default" icon="pi pi-play-circle"
            (click)="executeAction()"></button>
          <wl-busy [show]="executing"></wl-busy>
          <img src="/assets/img/help.png" title="{{ 'benefits.benefit-mgt.actions-help' | translate }}"
            class="wc-help-icon mv-10" />
        </span>
      </div>
    </div>
  </div>

  <p-table [showGridlines]="true" #benefitsDataGrid [lazy]="true" [rows]="10" [value]="benMgtComonentModel.benefits.Result" [paginator]="true"
    (onLazyLoad)="lazyLoadBenefits($event)" [totalRecords]="benMgtComonentModel.benefits.TotalCount"
    [sortField]="'ReportName'">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 50px">
          <div class="flex column items-center w-100">
            <input [(ngModel)]="benMgtComonentModel.selectAllProfiles"
              (ngModelChange)="onSelectAllChange(benMgtComonentModel.selectAllProfiles)" type="checkbox" />
          </div>
        </th>
        <th [pSortableColumn]="'ProfileId'" style="width: 120px; text-align: center !important">
          {{ 'common.personal-information.profile-id' | translate | titlecase }}
          <p-sortIcon field="ProfileId"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ReportName'">
          {{ 'common.personal-information.profile-name' | translate | titlecase }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th>{{ 'benefits.benefit-mgt.membership-level-label' | translate | titlecase }}</th>
        <th [pSortableColumn]="'ProfileStatus'">
          {{ 'benefits.benefit-mgt.profile-status-label' | translate | titlecase }}
          <p-sortIcon field="ProfileStatus"></p-sortIcon>
        </th>
        <th style="text-align: center !important">{{ 'benefits.benefit-mgt.total-value-label' | translate | titlecase }}
        </th>
        <th style="text-align: center !important">{{ 'benefits.benefit-mgt.used-value-label' | translate | titlecase }}
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template let-item pTemplate="body">
      <tr>
        <td>
          <div class="flex column items-center w-100">
            <input [(ngModel)]="item.Selected" (ngModelChange)="onProfileBenefitSelectedChange(item)" type="checkbox" />
          </div>
        </td>
        <td style="text-align: center !important">{{ item.ProfileId }}</td>
        <td>{{ item.ReportName }}</td>
        <td>{{ item.MembershipLevelName }}</td>
        <td>{{ item.ProfileStatus }}</td>
        <td style="text-align: center !important">{{ item.BenefitTotalValue | currency }}</td>
        <td style="text-align: center !important">{{ item.BenefitUsedValue | currency }}</td>
        <td style="text-align: center !important">
          <a class="btn btn-default" [routerLink]="['/benefits/profile/' + item.ProfileId.toString()]">
            <span class="pi pi-pencil"></span>
          </a>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="8">
          <wl-busy [show]="isSearching"></wl-busy>
          <div class="mct-flex mct-justify-end mct-items-stretch" [hidden]="isSearching">
            {{ benMgtComonentModel.benefits.TotalCount }}
            {{ 'benefits.profile-benefit-mgt.profiles-label' | translate | titlecase }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>

  <p-dialog #addBenefitsModal [(visible)]="showAddBenefitModal" modal="true" [closable]="false"
    styleClass="atlas-dialog-xl" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
    <ng-template pTemplate="header">
      <strong>{{ 'benefits.profile-benefit-mgt.add-benefit-title' | translate | titlecase }}</strong>
    </ng-template>
    <wl-benefit-add #addBenefitModal [(benefit)]="benefit" [createMode]="true"
      [(useDuesBillingDate)]="useDuesBillingDate"></wl-benefit-add>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving" icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase" (click)="addBenefitsModal.close()"></button>
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="isSaving" icon="pi pi-save"
        (click)="saveBenefits()"
        [label]="isSaving ? ('common.saving' | translate | titlecase) : ('common.save' | translate | titlecase)"></button>
    </ng-template>
  </p-dialog>

  <p-dialog #flagBenefitModal [(visible)]="showFlagBenefitModal" modal="true" [closable]="false"
    styleClass="atlas-dialog-xl" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
    <wl-benefit-flag [typeVisible]="true" [(benefitFlag)]="benefitFlag"></wl-benefit-flag>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" [disabled]="isSaving" icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase" (click)="flagBenefitModal.close()"></button>
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      <button pButton type="button" class="atlas-btn atlas-btn-primary tall" [disabled]="isSaving" icon="pi pi-save"
        (click)="flagBenefits()"
        [label]="isSaving ? ('common.saving' | translate | titlecase) : ('common.save' | translate | titlecase)"></button>
    </ng-template>
  </p-dialog>
</div>
